<template>
  <div class="employee">
    <div class="grid-content maintitle">
      <span>{{$t('message.员工管理')}}</span>
    </div>
    <div ref="cp">
      <!--组织架构图-->
      <table>
        <tr>
          <div :style="{ width: '225px' }">
            <!--组织架构标题和按钮-->
            <div class="grid-content content-margin">
              <span
                class="simpleLabel"
                :style="{ float: 'left', 'margin-top': '25px' }"
                >{{$t('message.员工列表')}}</span
              >

              <el-button
                slot="reference"
                size="mini"
                round
                :style="{ float: 'right' , 'margin-top': '18px' }"
                @click="onClickAdd"
              >
                <i class="iconfont">&#xe727;</i>
                {{$t('message.添加')}}
              </el-button>
            </div>

            <!--组织架构树形控件-->
            <div class="grid-content content-margin">
              <el-tree
                ref="tree"
                :data="this.treedata"
                stripe
                border
                :props="defaultProps"
                @node-click="onClickTree"
                :default-expand-all="true"
                :expand-on-click-node="false"
                node-key="key"
                :empty-text="$t('message.暂无数据')"
                :style="{ height: this.treeHeight + 'px' }"
                class="tree-menu"
                :highlight-current="true"
                :render-content="renderContent"
              >
              </el-tree>
            </div>
          </div>

          <td>
            <EmployeeEdit
              v-bind:clientHeight="this.commonHight - 175"
              :employeeid="this.currentNode.value"
              @onRefresh="refresh"
              @onBack="onBackAdd"
              :isAddMode="isAddMode"
            ></EmployeeEdit>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import EmployeeEdit from "@/components/Organization/EmployeeEdit.vue";
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

//节点类型
var organizationTreeType = {};
organizationTreeType.Organization = 0;
organizationTreeType.Department = 1;
organizationTreeType.Job = 2;
organizationTreeType.Employee = 3;

export default {
  name: "Employee",
  components: {
    EmployeeEdit,
  },

  data() {
    return {
      appid: 188,
      commonHight: 1500,
      treeHeight: 200,
      addWidth: 300,
      currentNode: {},

      treedata: [],
      serverdata: [],

      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
        value: null,
      },
      isAddMode: false,
    };
  },

  methods: {
    renderContent(h, { node, data, store }) {
      let addElement = arguments[0];
      if (data.type == 0 && data.value == 0) {
        return addElement("span", [
          addElement("i", { class: "el-icon-monitor" }),
          addElement("span", "    "),
          addElement("span", arguments[1].node.label),
        ]);
      } else if (data.type == 0 && data.value == 1) {
        return addElement("span", [
          addElement("i", { class: "el-icon-circle-close" }),
          addElement("span", "    "),
          addElement("span", arguments[1].node.label),
        ]);
      } else if (data.type == 0 && data.value == 2) {
        return addElement("span", [
          addElement("i", { class: "el-icon-delete" }),
          addElement("span", "    "),
          addElement("span", arguments[1].node.label),
        ]);
      } else if (data.type == 1) {
        return addElement("span", [
          addElement("i", { class: "el-icon-user" }),
          addElement("span", "    "),
          addElement("span", arguments[1].node.label),
        ]);
      }
    },

    onClickTree() {
      let tempNode = this.$refs.tree.getCurrentNode();
      if (tempNode.type == 0) {
        return;
      }
      this.currentNode = this.$refs.tree.getCurrentNode();
    },

    onClickAdd() {
      this.isAddMode = true;
    },

    onBackAdd() {
      this.isAddMode = false;
      this.refresh();
    },

    refresh() {
      this.$http
        .get("/manage/organization/employee/getlist", {
          params: {
            appid: this.appid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            //清除原来树节点
            this.treedata.forEach((node) => {
              this.$refs.tree.remove(node.key);
            });
            this.treedata.splice(0, this.treedata.length);

            //固定节点
            for (var i = 0; i < 3; ++i) {
              var head = {
                value: i,
                label: this.getEmployeeStateName(i),
                key: "state" + i,
                type: 0,
                children: [],
              };
              this.$refs.tree.append(head);
            }

            this.serverdata = doc.data.data;

            this.serverdata.forEach((item) => {
              var employeeData = {
                value: item.backaccountid,
                label: item.workname,
                key: "employee" + item.backaccountid,
                type: 1,
                children: [],
              };
              if (this.$refs.tree.getNode("state" + item.state)) {
                this.$refs.tree.append(employeeData, "state" + item.state);
              }
            });
          }
        });
    },

    getEmployeeStateName(state) {
      return commonUtil.getOrganizationStateName(state);
    },
  },

  mounted() {
    var el=document.querySelector('.el-main')
    console.log(el);
    el.style.overflow='hidden'
    this.$nextTick(function () {
      if (this.$refs.tree.$el !== "undefined")
        this.treeHeight =
          window.innerHeight - this.$refs.tree.$el.offsetTop - 50;
      this.commonHight = window.innerHeight - this.$refs.cp.offsetTop - 50;
      this.addWidth = window.innerWidth - this.$refs.cp.offsetLeft - 50;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.treeHeight =
          window.innerHeight - self.$refs.tree.$el.offsetTop - 50;
        self.commonHight = window.innerHeight - self.$refs.cp.offsetTop - 50;
        self.addWidth = window.innerWidth - self.$refs.cp.offsetLeft - 50;
      };
    });

    this.refresh();
  },

  created() {},
  destroyed(){
    var el=document.querySelector('.el-main')
    console.log(el);
    el.style.overflow='auto'
  }
};
</script>

<style scoped>
.tree-menu {
  overflow: auto;
  width: 100%;
}

.tree-menu > .el-tree-node {
  /*设置横向滚动条*/
  /* margin-right: 10px; */
  min-width: 100% !important;
  display: inline-block !important;
}
.employee /deep/ table{
  width: 100%;
}
.el-tree-node__content{
  box-sizing: content-box!important;
  min-width: 140px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/organization/Employee.vue